export default class CreateWorkTypePricingError extends Error {

}
